var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { maxBy, get } from 'lodash';
import { BlockButtonLinks } from './block-button-links';
import { classNames } from '../../utils/cn';
import { useEntity } from '../../hooks/use-entity';
import { entityColorInfo } from '../../utils/entity-color-info';
import { ContentNode } from './content-node';
var cls = classNames('slice-content-block-links');
export var SliceContentBlockLinksDefaultProps = {}; // -------- Styles -------->

var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    font-weight: 400;\n    display: flex;\n    flex-direction: column;\n  "], ["\n    font-weight: 400;\n    display: flex;\n    flex-direction: column;\n  "]))),
  desktop: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    flex-direction: row;\n  "], ["\n    flex-direction: row;\n  "])))
});
var ContentStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  "], ["\n  "]))),
  desktop: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    ", "\n   \n  "], ["\n    ", "\n   \n  "])), function (_a) {
    var maxCount = _a.maxCount;
    return maxCount && css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n       flex-basis: ", "%;\n    "], ["\n       flex-basis: ", "%;\n    "])), maxCount >= 2 ? 50 : maxCount * 66);
  })
});
var BlocksStyles = breakpoints({
  base: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    margin-top: ", ";\n  "], ["\n    display: flex;\n    flex-direction: column;\n    margin-top: ", ";\n  "])), theme.UNIT(6)),
  desktop: css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    margin-top: ", ";\n    margin-left: ", ";\n    \n    ", "\n  "], ["\n    margin-top: ", ";\n    margin-left: ", ";\n    \n    ", "\n  "])), theme.UNIT(1), theme.UNIT(6), function (_a) {
    var maxCount = _a.maxCount;
    return maxCount && css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n       flex-basis: ", "%;\n    "], ["\n       flex-basis: ", "%;\n    "])), maxCount >= 2 ? 50 : maxCount * 33);
  })
});
var LinksStyles = breakpoints({
  base: css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  "], ["\n  "])))
}); // -------- Components -------->

var My = {
  Container: styled.div(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Content: styled(ContentNode)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), ContentStyles),
  Blocks: styled.div.attrs(cls.attr('blocks'))(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), BlocksStyles),
  Links: styled(BlockButtonLinks)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["", ""], ["", ""])), LinksStyles)
};
export var SliceContentBlockLinks = function SliceContentBlockLinks(props) {
  var className = props.className,
      children = props.children;
  var entity = useEntity(props.entity);
  var content = entity.content,
      _a = entity.blocks,
      blocks = _a === void 0 ? [] : _a;
  var color = entityColorInfo(entity).color;
  var maxLinksPerBlock = get(maxBy(blocks, function (block) {
    return get(block, 'links.length', 0);
  }), 'links.length', 0);
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, React.createElement(My.Content, {
    maxCount: maxLinksPerBlock,
    entity: content
  }), !!blocks.length && maxLinksPerBlock && React.createElement(My.Blocks, {
    maxCount: maxLinksPerBlock || 1
  }, blocks.map(function (block) {
    return React.createElement(My.Links, {
      color: color,
      hoverColor: '#000',
      key: block.id,
      entity: block
    });
  })));
};
SliceContentBlockLinks.defaultProps = SliceContentBlockLinksDefaultProps;
SliceContentBlockLinks.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13;